import { get } from 'lodash'
import { v4 as uuidv4 } from 'uuid'
import axios from 'axios'
import store from '../store'

export const manipulateAnchorTags = function (value) {
  var div = document.createElement('div')
  div.innerHTML = value

  var notes = div.getElementsByClassName('note')
  for (let i = 0; i < notes.length; i++) {
    const href = notes[i].href.substring(notes[i].href.lastIndexOf('/') + 1)
    const note = store.getters.noteByName(href)
    if (note) {
      notes[i].id = 'note-' + parseInt(i + 1) + note.name
      notes[i].href = 'javascript:void(0)'
    }
  }

  var references = div.getElementsByClassName('reference')
  for (let i = 0; i < references.length; i++) {
    const href = references[i].href.substring(references[i].href.lastIndexOf('/') + 1)
    const reference = store.getters.referenceByName(href)
    if (reference) {
      references[i].id = 'ref-' + parseInt(i + 1) + reference.name
      references[i].href = 'javascript:void(0)'
    }
  }

  return div.innerHTML
}

function isActiveSession () {
  const storedSessionDate = sessionStorage.getItem('sessionDate')
  if (storedSessionDate) {
    var halfADayAgo = new Date().getTime() + (12 * 60 * 60 * 1000)
    if (new Date(storedSessionDate) < halfADayAgo) {
      return true
    }
  }
  return false
}

function setSession () {
  const uuid = uuidv4()
  sessionStorage.setItem('sessionId', uuid)
  sessionStorage.setItem('sessionDate', new Date())
  return uuid
}

function getSessionId () {
  const sessionId = sessionStorage.getItem('sessionId')
  if (!isActiveSession() || !sessionId) {
    return setSession()
  }
  return sessionId
}

export function clickTracker (moduleKey, optionalParams = {}) {
  axios.post('logAccessEvent', {
    webPageKey: moduleKey,
    sessionId: getSessionId(),
    ...optionalParams
  })
}

export const isInternetExplorer = function () {
  return /(MSIE|Trident\/)/i.test(navigator.userAgent)
}

export function isContainerApp () {
  return isNativeAndroid() || isNativeIos()
}

function isNativeAndroid () {
  return !!getAndroidScriptContext()
}

function isNativeIos () {
  return !!getIosScriptContext()
}

function getAndroidScriptContext () {
  return get(window, 'android')
}

function getIosScriptContext () {
  return get(window, 'webkit.messageHandlers.invokeAction')
}
